/** Dropdown values aligned with legacy pod-rfid-ui `config/Constants.js` + Allot UDFs. */

export type LabeledOption = { value: string; label: string };

export const TRANSPORT_MODES: LabeledOption[] = [
  { value: '001', label: 'Dedicated Transport' },
  { value: '002', label: 'By Hand' },
  { value: '003', label: 'By Courier' },
  { value: '004', label: 'Standard Transport' },
  { value: '005', label: 'Truck' },
  { value: '006', label: 'Mail' },
  { value: '007', label: 'Rail' },
  { value: '008', label: 'Sea' },
  { value: '009', label: 'Part Load' },
  { value: '010', label: 'By Air' },
  { value: '011', label: 'Vendor transport' },
];

export const VEHICLE_TYPES: LabeledOption[] = [
  { value: '101', label: '10FT Vehicle' },
  { value: '102', label: '12ft Vehicle' },
  { value: '103', label: '14Ft Vehicle' },
  { value: '104', label: '14ft Part Load' },
  { value: '105', label: '16MT' },
  { value: '106', label: '17ft Part Load' },
  { value: '107', label: '17ft Vehicle' },
  { value: '108', label: '19ft Part Load' },
  { value: '109', label: '19ft Vehicle' },
  { value: '110', label: '20ft Part Load' },
  { value: '111', label: '20ft Vehicle' },
  { value: '112', label: '21ft Vehicle' },
  { value: '113', label: '22ft Part Load' },
  { value: '114', label: '22ft Vehicle' },
  { value: '115', label: '24 Ft Vehicle' },
  { value: '116', label: '25ft MXL' },
  { value: '117', label: '32ft MXL' },
  { value: '118', label: '32ft MXL Part Load' },
  { value: '119', label: '32ft SXL' },
  { value: '120', label: '32ft SXL Part Load' },
  { value: '121', label: '34ft Vehicle' },
  { value: '122', label: '36ft Vehicle' },
  { value: '123', label: '40ft Container Trailer' },
  { value: '124', label: '40ft Container Trailer Part Load' },
  { value: '125', label: '40ft Open Trailer' },
  { value: '126', label: '40ft Open Trailer Part Load' },
  { value: '127', label: 'Auto' },
  { value: '128', label: 'By Hand' },
  { value: '129', label: 'CNG Auto' },
  { value: '130', label: 'Courier' },
  { value: '131', label: 'PART LOAD' },
  { value: '132', label: 'PORTER' },
  { value: '133', label: 'Pick Up' },
  { value: '134', label: 'Tata 407' },
  { value: '135', label: 'Tata Ace' },
  { value: '136', label: 'Two Wheeler' },
  { value: '137', label: 'VIRTUAL TRANSACTION' },
  { value: '138', label: 'Mahindra Pickup' },
  { value: '139', label: '32ft SXL - 7 Ton' },
  { value: '140', label: '32ft SXL - 9 Ton' },
  { value: '141', label: '32ft MXL HQ' },
  { value: '142', label: '40ft trailer' },
  { value: '143', label: '40ft Container' },
  { value: '144', label: '27ft' },
  { value: '145', label: '28ft' },
  { value: '146', label: '32ft SXL - 7 Ton' },
  { value: '147', label: '32ft SXL - 9 Ton' },
  { value: '148', label: '32ft MXL - 12 Ton' },
  { value: '149', label: '32ft MXL HQ- 15 Ton' },
  { value: '150', label: '32ft MXL HQ- 18 Ton' },
  { value: '151', label: 'NA' },
];

export const TRANSPORT_BY_LIST: LabeledOption[] = [
  { value: '101', label: 'LEAP Transport borne by customer' },
  { value: '102', label: 'Customer Transport' },
  { value: '103', label: 'Vendor Transport' },
  { value: '104', label: 'LEAP Transport borne by LEAP' },
  { value: '105', label: 'By Hand' },
  { value: '106', label: 'Dedicated Transport' },
  { value: '107', label: 'TARON Transport borne by customer' },
  { value: '108', label: 'TARON Transport borne by LEAP' },
  { value: '109', label: 'TARON Transport borne by TARON' },
  { value: '110', label: 'Partial Transportation' },
  { value: '111', label: 'Customer TPT' },
  { value: '112', label: 'VENDOR TPT' },
  { value: '113', label: 'BY HAND' },
  { value: '114', label: 'COURIER' },
  { value: '115', label: 'Virtual' },
];

export const EWAY_OPTIONS = [
  'Regular',
  'Bill To - Ship To',
  'Bill From - Dispatch From',
  'Combination of 2 and 3',
] as const;

export const POD_OPTIONS = ['Y', 'N'] as const;

export const REASON_OPTIONS = [
  'As per Plan',
  'As per SO',
  'As per Vehicle Capacity',
  'BBR material return',
  'Change in Customer location',
  'Change in plan',
  'Change in relocation plan',
  'Change in Vehicle',
  'CN not received from Vendor',
  'Delay in customer transport placement',
  'Delay in Vehicle placement',
  'Details not mentioned',
  'Direct Allot',
  'Dismantle Pallet Write Off',
  'Duplicate entry',
  'Early Docket creation (customer transport)',
  'Incorrect details in RR',
  'Incorrect GRPO done',
  'Incorrect Input',
  'Incorrect Invoice from Vendor',
  'Incorrect quantity',
  'Intransit Loss',
  'Invoice cancelled',
  'Issue in Unloading point (customer location)',
  'Items missed while document creation',
  'Manual booking as an execption',
  'Material got rejected',
  'Material not available',
  'Material not Procured',
  'Material Unavailable',
  'Mismatch in received Qty',
  'Mistake in document creation',
  'More than vehicle capacity',
  'Non LEAP asset received',
  'On hold by CC Team',
  'On hold by Planning',
  'On Hold by sales',
  'Order cancelled',
  'Order cancelled by customer',
  'Others - Not Covered',
  'Partial document creation',
  'Punched Mistakenly',
  'Quality issue',
  'Reversal of Movement',
  'Revision of previous data',
  'RFID Issue',
  'RTD not available',
  'RTD not available (Repairs not Done)',
  'RTD not available (Warehouse inventory mismatch)',
  'Same day plan',
  'SKU Mismatch',
  'System error',
  'Technical issue',
  'Vehicle Breakdown',
  'Vehicle Cancelled',
  'Vehicle detained by Officials',
  'Vehicle diverted as Customer denied',
  'Vehicle Rejected by Customer (Quality)',
  'Vendor material got rejected',
  'Wrong Details provided',
  'Wrong docket punched',
  'Wrong Item selected',
  'Wrong PO',
  'Wrong SO created',
] as const;

export function findOptionLabel(options: LabeledOption[], value: string): string {
  const v = value?.trim();
  if (!v) return '';
  const hit = options.find((o) => o.value === v || o.label === v);
  return hit ? `${hit.value} : ${hit.label}` : v;
}

export function resolveOptionValue(
  options: LabeledOption[],
  raw: string | undefined
): string {
  const v = String(raw ?? '').trim();
  if (!v) return '';
  const byValue = options.find((o) => o.value === v);
  if (byValue) return byValue.value;
  const byLabel = options.find((o) => o.label === v);
  if (byLabel) return byLabel.value;
  const partial = options.find(
    (o) => v.includes(o.value) || v.includes(o.label) || o.label.includes(v)
  );
  return partial?.value ?? v;
}
